import { Component } from 'react';
import { withUtils } from '../utils';
import { withStyles } from "@material-ui/core/styles";
import cloneDeep from 'lodash/cloneDeep';

import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import uuid from 'react-uuid';

const styles = theme => ({
});

class QuestionFormContent extends Component {
    shouldComponentUpdate(nextProps, nextState) { 
        return (
            this.props.simple !== nextProps.simple
        );
    }

    render() {
        const QuestionFormTag = this.props.simple ? QuestionSimpleFormContent : QuestionAdvancedFormContent;

        return (
            <QuestionFormTag {...this.props} {...this.state}/>
        );
    }
}

const style_single = 'single';
const style_multiple = 'multiple';
const style_dropdown = 'dropdown';
const style_slider = 'slider';

class QuestionSimpleFormContent extends Component {
    constructor(props) {
        super(props);

        let style = props.metadata._style;

        if (!style) {
            if (props.maximum_answers === 1) {
                style = style_single;
            } else {
                style = style_multiple;
            }
        }

        this.state = {
            question_id: props.question_id || uuid(),
            active: props.active === null ? true : props.active,
            priority: props.priority || 10,
            locales: cloneDeep(props.locales),
            minimum_answers: props.minimum_answers || 1,
            maximum_answers: props.maximum_answers,
            max_responses_per_user: props.max_responses_per_user,

            dependencies: cloneDeep(props.dependencies),
            targeting: cloneDeep(props.targeting),
            metadata: cloneDeep(props.metadata),

            style: style,

            tags: props.tags,
            categories: props.categories,
        };
    }

    shouldComponentUpdate(nextProps, nextState) { 
        return (
            this.state.question_id !== nextState.question_id ||
            this.state.active !== nextState.active ||
            this.state.priority !== nextState.priority ||
            this.state.locales !== nextState.locales ||
            this.state.minimum_answers !== nextState.minimum_answers ||
            this.state.maximum_answers !== nextState.maximum_answers ||
            this.state.max_responses_per_user !== nextState.max_responses_per_user ||
            this.state.dependencies !== nextState.dependencies ||
            this.state.targeting !== nextState.targeting ||
            this.state.metadata !== nextState.metadata ||
            this.state.style !== nextState.style ||
            this.state.tags !== nextState.tags ||
            this.state.categories !== nextState.categories ||
            this.props.accountCategories !== nextProps.accountCategories ||
            this.props.accountTags !== nextProps.accountTags
        );
    }

    _stateToPayload() {
        let metadata = cloneDeep(this.state.metadata);
        let minimum_answers;
        let maximum_answers;

        if (this.state.style === style_single) {
            minimum_answers = 1;
            maximum_answers = 1;
            delete metadata._style;

        } else if (this.state.style === style_multiple) {
            minimum_answers = 1;
            maximum_answers = null;
            delete metadata._style;

        } else if (this.state.style === style_dropdown) {
            minimum_answers = 1;
            maximum_answers = 1;
            metadata._style = style_dropdown;

        } else if (this.state.style === style_slider) {
            minimum_answers = 1;
            maximum_answers = 1;
            metadata._style = style_slider;

        }

        let payload = {
            question_id: this.state.question_id,
            active: this.state.active,
            priority: this.state.priority,
            locales: this.state.locales,
            minimum_answers: minimum_answers,
            maximum_answers: maximum_answers,
            max_responses_per_user: this.state.max_responses_per_user,

            dependencies: this.state.dependencies,
            targeting: this.state.targeting,
            metadata: metadata,

            tags: this.state.tags,
            categories: this.state.categories,
        };

        return payload;
    }


    updateState(opts) {
        this.setState(
            opts,
            function() {
                if (this.props.onChange) {
                    const data = this._stateToPayload();
                    this.props.onChange(data);

                } else {
                    console.warn('probably want an onChange handler here');
                }
            }
        );
    }

    updateLocale(locale, state) {
        var updated = false;
        var locales = this.state.locales;

        for (var i = 0; i < locales.length; i++) {
            if (locales[i].locale === locale) {
                locales[i] = state;
                updated = true;
                break;
            }
        }

        if (!updated) {
            locales.push(state);
        }

        this.updateState({
            locales: locales
        });
    }

    render() {
        const me = this;
        
        return (
            <div className="question-form">
                <div className="question-locales">
                {
                    this.state.locales.map(function (locale) {
                        return (
                            <QuestionLocale
                                key={locale}
                                label={locale.locale}
                                locale={locale.locale}
                                content={locale.content}
                                pre_text={locale.pre_text}
                                post_text={locale.post_text}
                                onChange={(state) => me.updateLocale(locale.locale, state)}
                            />
                        );
                    })
                }
                </div>
                <div className="flex-group">
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={this.state.active}
                                    onChange={(e) => this.updateState({ active: e.target.checked })}
                                    name="active"
                                    color="primary"
                                />
                            }
                            label="Live question"
                        />
                        <FormHelperText>Can this question be served to users?</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <InputLabel required id="style-label">Question type</InputLabel>
                        <Select
                            labelId="style-label"
                            id="style"
                            required
                            value={this.state.style}
                            onChange={(e) => this.updateState({ style: e.target.value })}
                        >
                            <MenuItem value={style_single}>Single choice</MenuItem>
                            <MenuItem value={style_multiple}>Multiple choice</MenuItem>
                            <MenuItem value={style_dropdown}>Dropdown</MenuItem>
                            <MenuItem value={style_slider}>Slider</MenuItem>
                        </Select>
                        <FormHelperText>This effects how the question is presented to the user</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <InputLabel required id="priority-label">Priority</InputLabel>
                        <Select
                            labelId="priority-label"
                            id="priority"
                            required
                            value={this.state.priority}
                            onChange={(e) => this.updateState({ priority: e.target.value })}
                        >
                            <MenuItem value="1">Highest</MenuItem>
                            <MenuItem value="5">Higher</MenuItem>
                            <MenuItem value="10">Medium</MenuItem>
                            <MenuItem value="15">Lower</MenuItem>
                            <MenuItem value="20">Lowest</MenuItem>
                        </Select>
                        <FormHelperText>High priority questions will always be asked first</FormHelperText>
                    </FormControl>
                </div>
                <p>
                    Categories and tags can be used to choose questions to be used in surveys.
                </p>
                <div className="flex-group">
                    <FormControl>
                        <Autocomplete
                            id="categories"
                            multiple
                            freeSolo
                            onChange={(e, obj) => this.updateState({ categories: obj })}
                            value={this.state.categories}
                            options={this.props.accountCategories}
                            loading={this.props.accountCategories === null}
                            renderInput={(params) => (
                                <TextField {...params} label="Categories" margin="normal" variant="standard" />
                            )}
                        />
                        <FormHelperText>Which categories does this question belong in?</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <Autocomplete
                            id="tags"
                            multiple
                            freeSolo
                            value={this.state.tags}
                            options={this.props.accountTags}
                            loading={this.props.accountTags === null}
                            onChange={(e, obj) => this.updateState({ tags: obj })}
                            renderInput={(params) => (
                                <TextField {...params} label="Tags" margin="normal" variant="standard" />
                            )}
                        />
                        <FormHelperText>Which tags apply to this question?</FormHelperText>
                    </FormControl>
                </div>
            </div>
        );
    }
}

class QuestionAdvancedFormContent extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            question_id: props.question_id || "",
            active: props.active === null ? true: props.active,
            priority: props.priority || 3,
            locales: cloneDeep(props.locales),
            minimum_answers: props.minimum_answers || 1,
            maximum_answers: props.maximum_answers,
            max_responses_per_user: props.max_responses_per_user,

            dependencies: cloneDeep(props.dependencies),
            targeting: cloneDeep(props.targeting),
            metadata: cloneDeep(props.metadata),

            tags: props.tags,
            categories: props.categories,
        };
    }

    updateState(opts) {
        this.setState(
            opts,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state);

                } else {
                    console.warn('probably want an onChange handler here');
                }
            }
        );
    }

    updateLocale(locale, state) {
        var updated = false;
        var locales = this.state.locales;

        for (var i = 0; i < locales.length; i++) {
            if (locales[i].locale === locale) {
                locales[i] = state;
                updated = true;
                break;
            }
        }

        if (!updated) {
            locales.push(state);
        }

        this.updateState({
            locales: locales
        });
    }

    render() {
        const me = this;
        
        return (
            <div className="question-form">
                <h3>Question basics</h3>
                <div className="flex-group">
                    <FormControl>
                        <TextField required id="question-id" label="ID" value={this.state.question_id} onChange={(e) => this.updateState({ question_id: e.target.value })} />
                        <FormHelperText>Unique identifier for this question.</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.active}
                                    onChange={(e) => this.updateState({ active: e.target.checked })}
                                    name="active"
                                    color="primary"
                                />
                            }
                            label="Active"
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            id="priority"
                            label="Priority"
                            type="number"
                            min="1"
                            required
                            value={this.state.priority}
                            onChange={(e) => this.updateState({ priority: e.target.value || null })}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <FormHelperText>A lower number results in this question more likely being chosen</FormHelperText>
                    </FormControl>
                </div>
                <h3>Content</h3>
                <div className="question-locales">
                {
                    this.state.locales.map(function (locale) {
                        return (
                            <QuestionLocale
                                key={locale}
                                label={locale.locale}
                                locale={locale.locale}
                                content={locale.content}
                                pre_text={locale.pre_text}
                                post_text={locale.post_text}
                                onChange={(state) => me.updateLocale(locale.locale, state)}
                            />
                        );
                    })
                }
                </div>
                <h3>Restrictions</h3>
                <p>
                    Questions will be chosen to be part of a survey based on whether they match the categorye and tag chosen to be part of the survey. You can create as many as you like
                </p>
                <div className="flex-group">
                    <FormControl>
                        <Autocomplete
                            id="categories"
                            multiple
                            freeSolo
                            onChange={(e, obj) => this.updateState({ categories: obj })}
                            value={this.state.categories}
                            options={this.props.accountCategories}
                            loading={this.props.accountCategories === null}
                            renderInput={(params) => (
                                <TextField {...params} label="Categories" margin="normal" variant="standard" />
                            )}
                        />
                        <FormHelperText>Which categories does this question belong in?</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <Autocomplete
                            id="tags"
                            multiple
                            freeSolo
                            value={this.state.tags}
                            options={this.props.accountTags}
                            loading={this.props.accountTags === null}
                            onChange={(e, obj) => this.updateState({ tags: obj })}
                            renderInput={(params) => (
                                <TextField {...params} label="Tags" margin="normal" variant="standard" />
                            )}
                        />
                        <FormHelperText>Which tags apply to this question?</FormHelperText>
                    </FormControl>
                </div>
                {/*
                <p>
                </p>
                <div className="flex-group">
                    <FormDropdown label="Categories" description="Which categories does this question belong?" options={this.state.categories} selected={this.state.} onChange={(state) => this.updateState({ priority: state.selected }) } />
                    Tags
                </div>
                */}
                <p>
                    Most questions will only have a single answer, in which
                    case the minimum and maximum answers should be 1. Sometimes you
                    want multiple choice, in which case you can leave the maximum
                    answers blank to indicate no limit. Should you want a user
                    to choose exactly 3 answers you can set both of these to that
                    number.
                </p>
                <p>
                    You can control how many times a particular user can answer
                    this question. They will only ever be asked the question once per
                    survey, but they may complete the survey several times.
                </p>
                <div className="flex-group">
                    <FormControl>
                        <TextField
                            id="minimum-answers"
                            label="Minimum answers"
                            type="number"
                            min="1"
                            required
                            value={this.state.minimum_answers}
                            onChange={(e) => this.updateState({ minimum_answers: e.target.value || null })}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <FormHelperText>How many answers must a user choose?</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <TextField
                            id="maximum-answers"
                            label="Maximum answers"
                            type="number"
                            min={this.state.minimum_answers}
                            value={this.state.maximum_answers || ""}
                            onChange={(e) => this.updateState({ maximum_answers: e.target.value || null })}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <FormHelperText>What's the most number of answers a user can choose?</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <TextField
                            id="max-responses-per-user"
                            label="Max responses per user?"
                            type="number"
                            min="1"
                            value={this.state.max_responses_per_user || ""}
                            onChange={(e) => this.updateState({ max_responses_per_user: e.target.value || null })}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <FormHelperText>How many times do you want the same person to answer this question?</FormHelperText>
                    </FormControl>
                </div>
                {/*
                <div className="flex-group">
                    <FormText type="number" description="How many answers must a user choose?" label="Minimum answers" value={this.state.minimum_answers} onChange={(state) => {this.updateState({ minimum_answers: state.value })}} />
                    <FormText type="number" description="What's the most number of answers a user can choose?" label="Maximum answers" value={this.state.maximum_answers} onChange={(state) => {this.updateState({ maximum_answers: state.value })}} />
                    <FormText type="number" description="How many times do you want the same person to answer this question?" label="Max responses per user" value={this.state.max_responses_per_user} onChange={(state) => {this.updateState({ max_responses_per_user: state.value })}} />
                </div>
                    */}
            </div>
        );
    }
}

QuestionAdvancedFormContent = withUtils(QuestionAdvancedFormContent);

class QuestionLocale extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: this.props.content,
            pre_text: this.props.pre_text,
            post_text: this.props.post_text,
            locale: this.props.locale
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.content !== nextState.content ||
            this.state.pre_text !== nextState.pre_text ||
            this.state.post_text !== nextState.post_text ||
            this.state.locale !== nextState.locale
        );
    }

    handleOnChange(state) {
        this.setState(
            state,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state);

                } else {
                    console.warn('probably want a onChange handler here');
                }
            }
        );
    }

    render() {
        return (
            <div className="question-locale">
                <div className="flex-group">
                    <FormControl>
                        <TextField
                            required
                            id={'content-' + this.state.locale}
                            label="Type your question here"
                            value={this.state.content}
                            onChange={(e) => this.handleOnChange({ content: e.target.value })}
                        />
                    </FormControl>
                </div>
                <div className="flex-group">
                    <FormControl>
                        <TextField
                            label="Brief description to appear before the answers"
                            id={'pre-text-' + this.state.locale}
                            value={this.state.pre_text}
                            onChange={(e) => this.handleOnChange({ pre_text: e.target.value })}
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            label="Text which will appear after the answers"
                            id={'post-text-' + this.state.locale}
                            value={this.state.post_text}
                            onChange={(e) => this.handleOnChange({ post_text: e.target.value })}
                        />
                    </FormControl>
                </div>
            </div>
        );
    }
}

class AnswerLocale extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: this.props.content,
            locale: this.props.locale
        };

        this.handleOnChange = this.handleOnChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.content !== nextState.content ||
            this.locale !== nextState.locale
        );
    }

    handleOnChange(state) {
        this.setState(
            state,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state);

                } else {
                    console.warn('probably want a onChange handler here');
                }
            }
        );
    }

    render() {
        return (
            <FormControl className="answer-locale">
                <TextField
                    id={'answer-content-' + this.state.locale}
                    label="What is this answer?"
                    required
                    value={this.state.content}
                    onChange={(e) => this.handleOnChange({ content: e.target.value }) }
                />
            </FormControl>
        );
    }
}

class AnswersFormContent extends Component {
    constructor(props) {
        super(props);

        var counter = 0;
        var answers = cloneDeep(props.answers);
        var counters = answers.map(function (answer, index) {
            return ++counter;
        });

        this.state = {
            counter: counter,
            counters: counters,
            answers: answers
        };
    }

    updateState(newState) {
        this.setState(
            newState,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state.answers);
                } else {
                    console.warn('probably want an onChange handler here');
                }
            }
        );
    }

    updateAnswer(counter, state) {
        const me = this;

        var answers = this.state.answers.map(function (answer, index) {
            if (me.state.counters[index] === counter) {
                answer = cloneDeep(state);
            }

            return answer;
        });

        this.updateState({
            answers: answers,
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.simple !== nextProps.simple ||
            this.state.counter !== nextState.counter ||
            this.state.counters.length !== nextState.counters.length ||
            this.state.answers.length !== nextState.answers.length
        );
    }

    addAnswer(e) {
        var answers = this.state.answers;
        var counters = this.state.counters;
        var counter = this.state.counter;
        var newAnswer = cloneDeep(this.props.answerDefaults);

        answers.push(newAnswer);
        counters.push(++counter);

        this.updateState({
            answers: answers,
            counter: counter,
            counters: counters,
        });

        if (e) {
            e.preventDefault();
        }

        return false;
    }

    removeAnswer(counter) {
        if (this.state.answers.length > 1 && window.confirm('Are you sure?')) {
            const me = this;

            const answers = this.state.answers.filter(function (a, index) {
                return me.state.counters[index] !== counter;
            });
            const counters = this.state.counters.filter(function (c, index) {
                return c !== counter;
            });

            this.updateState({
                answers: answers,
                counters: counters,
            });
        }
    }

    render() {
        const me = this;
        const AnswerFormTag = this.props.simple ? AnswerSimpleFormAccordian : AnswerAdvancedFormContent;

        return (
            <div className="answers-list">
                <h3>Answers</h3>
                {
                    this.state.answers.map(function (answer, index) {
                        return (
                            <AnswerFormTag
                                key={me.state.counters[index]}
                                answer_id={answer.answer_id}
                                value={answer.value}
                                active={answer.active}
                                more_detail={answer.more_detail}
                                locales={answer.locales}
                                metadata={answer.metadata}
                                onChange={(state) => me.updateAnswer(me.state.counters[index], state)}
                                onDelete={(state) => me.removeAnswer(me.state.counters[index])}
                            />
                        );
                    })
                }
                <p>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={(e) => this.addAnswer(e) }
                    >
                        Add answer
                    </Button>
                </p>
            </div>
        );
    }
}

class AnswerSimpleFormAccordian extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // don't ask for an answer for the simple stuffs, default to auto-generated uuid
            answer_id: props.answer_id || uuid(),
            value: props.value,
            active: props.active,
            more_detail: props.more_detail,
            locales: cloneDeep(props.locales),
            metadata: cloneDeep(props.metadata),
        };
    }

    remove(e) {
        this.props.onDelete(this.state);
        e.preventDefault();
        return false;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.answer_id !== nextState.answer_id ||
            this.state.value !== nextState.value ||
            this.state.active !== nextState.active ||
            this.state.more_detail !== nextState.more_detail ||
            this.state.locales.length !== nextState.locales.length
        );
    }
    
    updateState(opts) {
        this.setState(
            opts,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state);

                } else {
                    console.warn('probably want an onChange handler here');
                }
            }
        );
    }

    updateLocale(locale, state) {
        var updated = false;
        var locales = this.state.locales;

        for (var i = 0; i < locales.length; i++) {
            if (locales[i].locale === locale) {
                locales[i] = state;
                updated = true;
                break;
            }
        }

        if (!updated) {
            locales.push(state);
        }

        // for simple, always assume that the only locale is the value
        this.updateState({
            value: state.content,
            locales: locales
        });
    }

    render() {
        const me = this;
        const { classes } = this.props;

        return (
            <Accordion defaultExpanded={this.state.value === ""}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                >
                    <Typography className={classes.heading}>{this.state.value}</Typography>
                    <Typography className={classes.secondaryHeading}>{this.state.more_detail ? '(* Requires more details)' : ''}</Typography>

                </AccordionSummary>
                <AccordionDetails>  {/* className={classes.surveyDetails}> */}
                    <div className="answer-locales">
                    {
                        this.state.locales.map(function (locale) {
                            return (
                                <AnswerLocale
                                    key={locale}
                                    locale={locale.locale}
                                    content={locale.content}
                                    onChange={(state) => me.updateLocale(locale.locale, state)}
                                />
                            );
                        })
                    }
                    </div>
                    <FormControl>
                        <FormControlLabel
                            control={<Checkbox color="primary" checked={this.state.more_detail} onChange={(e) => this.updateState({ more_detail: e.target.checked })} name="" />}
                            label="User must provide more information"
                        />
                        <FormHelperText>If the user chooses this answer, they must provide extra text</FormHelperText>
                    </FormControl>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={this.state.active}
                                    onChange={(e) => this.updateState({ active: e.target.checked })}
                                    name=""
                                />
                            }
                            label="Active"
                        />
                        <FormHelperText>Temporarily disable an answer from being shown</FormHelperText>
                    </FormControl>
                    <div className="form-group">
                        <div>
                            <label>&nbsp;</label>
                            <IconButton color="primary" aria-label="delete answer" component="span" onClick={(e) => this.remove(e)}>
                                <DeleteForeverIcon />
                            </IconButton>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
        );
    }
}

AnswerSimpleFormAccordian = withUtils(withStyles(styles)(AnswerSimpleFormAccordian));

/*
class AnswerSimpleFormContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // don't ask for an answer for the simple stuffs, default to auto-generated uuid
            answer_id: props.answer_id || uuid(),
            value: props.value,
            active: props.active,
            more_detail: props.more_detail,
            locales: cloneDeep(props.locales),
            metadata: cloneDeep(props.metadata),
        };
    }

    remove(e) {
        this.props.onDelete(this.state);
        e.preventDefault();
        return false;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.answer_id !== nextState.answer_id ||
            this.state.value !== nextState.value ||
            this.state.active !== nextState.active ||
            this.state.more_detail !== nextState.more_detail ||
            this.state.locales.length !== nextState.locales.length
        );
    }
    
    updateState(opts) {
        this.setState(
            opts,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state);

                } else {
                    console.warn('probably want an onChange handler here');
                }
            }
        );
    }

    updateLocale(locale, state) {
        var updated = false;
        var locales = this.state.locales;

        for (var i = 0; i < locales.length; i++) {
            if (locales[i].locale === locale) {
                locales[i] = state;
                updated = true;
                break;
            }
        }

        if (!updated) {
            locales.push(state);
        }

        // for simple, always assume that the only locale is the value
        this.updateState({
            value: state.content,
            locales: locales
        });
    }

    render() {
        const me = this;

        return (
            <div className="answer flex-group">
                <div className="answer-locales">
                {
                    this.state.locales.map(function (locale) {
                        return (
                            <AnswerLocale
                                key={locale}
                                locale={locale.locale}
                                content={locale.content}
                                onChange={(state) => me.updateLocale(locale.locale, state)}
                            />
                        );
                    })
                }
                </div>
                <FormControl>
                    <FormControlLabel
                        control={<Checkbox color="primary" checked={this.state.more_detail} onChange={(e) => this.updateState({ more_detail: e.target.checked })} name="" />}
                        label="More detail?"
                    />
                    <FormHelperText>Answer needs extra details</FormHelperText>
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        control={<Checkbox color="primary" checked={this.state.active} onChange={(e) => this.updateState({ active: e.target.checked })} name="" />}
                        label="Active"
                    />
                </FormControl>
                <div className="form-group">
                    <div>
                        <label>&nbsp;</label>
                        <IconButton color="primary" aria-label="delete answer" component="span" onClick={(e) => this.remove(e)}>
                            <DeleteForeverIcon />
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    }
}
*/

class AnswerAdvancedFormContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            answer_id: props.answer_id,
            value: props.value,
            active: props.active,
            more_detail: props.more_detail,
            locales: cloneDeep(props.locales),
            metadata: cloneDeep(props.metadata),
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.answer_id !== nextState.answer_id ||
            this.state.value !== nextState.value ||
            this.state.active !== nextState.active ||
            this.state.more_detail !== nextState.more_detail ||
            this.state.locales.length !== nextState.locales.length
        );
    }

    remove(e) {
        this.props.onDelete(this.state);
        e.preventDefault();
        return false;
    }

    updateState(opts) {
        this.setState(
            opts,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state);

                } else {
                    console.warn('probably want an onChange handler here');
                }
            }
        );
    }

    updateLocale(locale, state) {
        var updated = false;
        var locales = this.state.locales;

        for (var i = 0; i < locales.length; i++) {
            if (locales[i].locale === locale) {
                locales[i] = state;
                updated = true;
                break;
            }
        }

        if (!updated) {
            locales.push(state);
        }

        this.updateState({
            locales: locales
        });
    }

    render() {
        const me = this;

        return (
            <div className="answer flex-group">
                <FormControl>
                    <TextField
                        label="Answer ID"
                        onChange={(e) => this.updateState({ answer_id: e.target.value })}
                        value={this.state.answer_id}
                        required
                    />
                    <FormHelperText>Unique answer ID</FormHelperText>
                </FormControl>
                <FormControl>
                    <TextField
                        id=""
                        label="Value"
                        required
                        onChange={(e) => this.updateState({ value: e.target.value })}
                        value={this.state.value}
                    />
                    <FormHelperText>This value will appear in reporting agaist this answer.</FormHelperText>
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        control={<Checkbox color="primary" checked={this.state.more_detail} onChange={(e) => this.updateState({ more_detail: e.target.checked })} name="" />}
                        label="More detail?"
                    />
                    <FormHelperText>Answer needs extra details</FormHelperText>
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={this.state.active}
                                onChange={(e) => this.updateState({ active: e.target.checked })}
                                name=""
                            />}
                        label="Active"
                    />
                </FormControl>
                <div className="answer-locales">
                {
                    this.state.locales.map(function (locale) {
                        return (
                            <AnswerLocale
                                key={locale}
                                locale={locale.locale}
                                content={locale.content}
                                onChange={(state) => me.updateLocale(locale.locale, state)}
                            />
                        );
                    })
                }
                </div>
                <div className="form-group">
                    <div>
                        <label>&nbsp;</label>
                        <IconButton color="primary" aria-label="delete answer" component="span" onClick={(e) => this.remove(e)}>
                            <DeleteForeverIcon />
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    }
}

class QuestionForm extends Component {
    constructor(props) {
        super(props);

        this.state = cloneDeep(props.question);
    }

    updateState(opts) {
        this.setState(
            opts,
            function() {
                if (this.props.onChange) {
                    this.props.onChange(this.state);

                } else {
                    console.warn('probably want an onChange handler here');
                }
            }
        );
    }

    shouldComponentUpdate(nextProps, nextState) { 
        return (
            this.props.simple !== nextProps.simple
        );
    }

    render() {
        return (
            <div>
                <QuestionFormContent
                    simple={this.props.simple}
                    accountTags={this.props.accountTags}
                    accountCategories={this.props.accountCategories}
                    onChange={(state) => this.updateState(state)}
                    {...this.state}
            />
                <AnswersFormContent
                    simple={this.props.simple}
                    answers={this.state.answers}
                    answerDefaults={this.props.answerDefaults}
                    onChange={(answers) => this.updateState({ answers: answers })}
                />
            </div>
        );
    }
}

export default QuestionForm;
